import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { inject, observer } from 'mobx-react';
import TweenMax from 'TweenMax';

import Container from '../Container';
import { clearfix, toVw, toVwMobile } from '../../utils/styles';
import Menu from './components/Menu';
import Logotype from './components/Logotype';
import Burger from './components/Burger';
import { invert } from '../../utils/theme';
import theme from '../../utils/theme';
import mq from '@/utils/media-queries';
import { isProduction } from '../../utils';

const Styled = styled.div`
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
`;

const TopContainer = styled.div`
  ${clearfix};
  position: fixed;
  z-index: 1;
  width: 100vw;
  padding-right: ${props => props.scrollbarWidth}px;
  box-sizing: border-box;
`;

const RelativeContainer = styled(Container)`
  position: relative;
  opacity: 0;
  visibility: hidden;
`;

const StyledLogotype = styled(Logotype)`
  position: absolute;
  top: ${toVw(36)};
  left: 0;
  z-index: 1;

  ${mq.mobile(css`
    top: ${toVwMobile(36)};
  `)};
`;

const StyledBurger = styled(Burger)`
  position: absolute;
  top: ${toVw(36)};
  right: 0;

  ${mq.mobile(css`
    top: ${toVwMobile(36)};
  `)};

  ${mq.mobile375(css`
    top: ${toVwMobile(36)};
  `)};
`;

class Header extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    menuVisible: PropTypes.bool.isRequired,
    menuStore: PropTypes.object.isRequired,
    preloaderFulfilled: PropTypes.bool.isRequired,
    themeIsDark: PropTypes.bool.isRequired,
    invertingBlockInViewport: PropTypes.bool.isRequired,
    scrollbarWidth: PropTypes.number,
  };

  componentDidMount() {
    if (!isProduction()) {
      this.show();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.preloaderFulfilled !== this.props.preloaderFulfilled) {
      if (nextProps.preloaderFulfilled) {
        this.show();
      }
    }
  }

  show() {
    TweenMax.to(this.containerNode, 0.35, { autoAlpha: 1, ease: Power1.easeOut });
  }

  toggleMenu() {
    this.props.menuVisible ? this.hideMenu() : this.showMenu();
  }

  hideMenu() {
    this.props.menuStore.hide();
  }

  showMenu() {
    this.props.menuStore.show();
  }

  render() {
    const { themeIsDark, menuVisible, invertingBlockInViewport, scrollbarWidth } = this.props;

    let topContainerTheme;

    switch (true) {
      case themeIsDark && !menuVisible:
      case !themeIsDark && menuVisible:
      case !themeIsDark && invertingBlockInViewport:
        topContainerTheme = invert;
        break;
      case themeIsDark && invertingBlockInViewport:
        topContainerTheme = theme;
        break;
      default:
        topContainerTheme = theme;
    }

    return (
      <Styled>
        <TopContainer scrollbarWidth={scrollbarWidth}>
          <ThemeProvider theme={topContainerTheme}>
            <RelativeContainer containerRef={node => (this.containerNode = node)}>
              <StyledLogotype />
              <StyledBurger onClick={() => this.toggleMenu()} />
            </RelativeContainer>
          </ThemeProvider>
        </TopContainer>
        <ThemeProvider theme={!themeIsDark ? invert : theme}>
          <Menu location={this.props.location} onHide={() => this.hideMenu()} onShow={() => this.showMenu()} />
        </ThemeProvider>
      </Styled>
    );
  }
}

export default inject(stores => ({
  themeStore: stores.store.theme,
  menuStore: stores.store.menuStore,
  preloaderStore: stores.store.preloaderStore,
  scrollControllerStore: stores.store.scrollControllerStore,
}))(
  observer(({ preloaderStore, themeStore, menuStore, scrollControllerStore, ...rest }) => (
    <Header
      preloaderFulfilled={preloaderStore.loaded}
      themeIsDark={themeStore.isDark}
      invertingBlockInViewport={themeStore.invertingBlockInViewport}
      menuVisible={menuStore.visible}
      menuStore={menuStore}
      scrollbarWidth={scrollControllerStore.scrollbarWidth}
      {...rest}
    />
  ))
);



// WEBPACK FOOTER //
// ./src/components/Header/index.js